import { useState } from "react";
import { ContactAPI } from "../../../api";
import { Field, Form, Formik } from "formik";
import { ContactSchema } from "../../../validation";
import { Turnstile } from "react-turnstile";

export default function ContactForm() {
    const [serverResponse, setServerResponse] = useState(null);

    const onSubmit = async (values, actions) => {
        try {
            const response = await ContactAPI(
                values.name,
                values.subject,
                values.email,
                values.message
            );

            setServerResponse(response);
            actions.resetForm();

            actions.setSubmitting(false);
        } catch (error) {
            console.log(error);
            actions.setSubmitting(false);
        }
    };

    return (
        <div className="contact-col">
            <div className="contact-form">
                <h2>Send us a message</h2>

                <Formik
                    initialValues={{
                        name: "",
                        subject: "",
                        email: "",
                        message: "",
                        turnstile: "",
                        agreement: false
                    }}
                    validationSchema={ContactSchema}
                    onSubmit={(values, actions) => onSubmit(values, actions)}
                >
                    {({
                        handleChange,
                        values,
                        errors,
                        touched,
                        isSubmitting,
                        isValid,
                        dirty,
                        setFieldValue,
                    }) => (
                        <Form>
                            <div className="form-group">
                                <label htmlFor="name">
                                    Name{" "}
                                    {errors.name && touched.name && (
                                        <span className="error-message">
                                            {errors.name}
                                        </span>
                                    )}
                                </label>
                                <div className="field-wrapper">
                                    <Field
                                        name="name"
                                        placeholder="Enter your name"
                                        id="name"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="subject">
                                    Subject{" "}
                                    {errors.subject && touched.subject && (
                                        <span className="error-message">
                                            {errors.subject}
                                        </span>
                                    )}
                                </label>
                                <div className="field-wrapper selectbox">
                                    {!values.subject && (
                                        <span className="select-placeholder">
                                            Choose subject
                                        </span>
                                    )}
                                    <Field
                                        as="select"
                                        name="subject"
                                        id="subject"
                                        onChange={handleChange}
                                    >
                                        <option disabled></option>
                                        <option value="Become a publisher">
                                            Become a publisher
                                        </option>
                                        <option value="Become an advertiser">
                                            Become an advertiser
                                        </option>
                                        <option value="Other">Other</option>
                                    </Field>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">
                                    Email{" "}
                                    {errors.email && touched.email && (
                                        <span className="error-message">
                                            {errors.email}
                                        </span>
                                    )}
                                </label>
                                <div className="field-wrapper">
                                    <Field
                                        name="email"
                                        type="mail"
                                        placeholder="Enter your email"
                                        id="email"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">
                                    Message{" "}
                                    {errors.message && touched.message && (
                                        <span className="error-message">
                                            {errors.message}
                                        </span>
                                    )}
                                </label>
                                <div className="field-wrapper">
                                    <Field
                                        as="textarea"
                                        id="message"
                                        name="message"
                                        rows="4"
                                        placeholder="Enter your message… (10 character minimum)"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="field-wrapper">
                                    <label className="checkbox-wrapper flex gap-2 leading-6">
                                        <Field
                                            type="checkbox"
                                            name="agreement"
                                            id="agreement"
                                            className="mr-1"
                                        />
                                        <span>
                                            I have read the company's privacy policy and I hereby give my explicit consent to the processing of my personal data within this scope.
                                        </span>
                                    </label>
                                </div>
                                {errors.agreement && touched.agreement && (
                                    <label>
                                        <span className="error-message">
                                            {errors.agreement}
                                        </span>
                                    </label>
                                )}
                            </div>

                            <div className="form-group">
                                <Turnstile
                                    sitekey="0x4AAAAAAFWXVz_XzDziDeCE"
                                    onVerify={(token) => {
                                        setFieldValue('turnstile', "token")
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                {serverResponse && (
                                    <label
                                        className={`message-container ${serverResponse?.statusCode === 200
                                            ? "success"
                                            : "error"
                                            }`}
                                    >
                                        <span
                                            className={`${serverResponse?.statusCode === 200
                                                ? "success-message"
                                                : "error-message"
                                                }`}
                                        >
                                            {serverResponse.message}
                                        </span>
                                    </label>
                                )}
                            </div>

                            <div className="form-group">
                                <button
                                    disabled={
                                        !isValid ||
                                        !dirty ||
                                        isSubmitting ||
                                        !values.agreement
                                    }
                                    type="submit"
                                    className="button-primary"
                                >
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
}